<div class="business-info-popup-root" *transloco="let t">
  <div *ngIf="!noLocale" class="header">
    <div class="locale-area">
      <span [class]="country"></span>
      <span>{{state}}</span>
    </div>
    <app-icon-click flat (click)="emitCloseClick($event)">cancel</app-icon-click>
  </div>
  <div *ngIf="hasFamily()">
    {{t('point-summary-for-family')}} {{familyName}}:
  </div>
  <div *ngIf="!hasFamily()" class="point-summary-all-title">
    {{t('point-summary-for-all-families')}}
  </div>
  <div class="content">
    <div class="first-band">
      <div class="first-band-left">
        <span>{{activePoints | number}}<mat-icon>stars</mat-icon></span>
        <span>{{t('total-active-points')}}</span>
      </div>
      <div *ngIf="noLocale" class="first-band-right">
        <app-icon-click flat (click)="emitCloseClick($event)">cancel</app-icon-click>
      </div>
    </div>
    <app-horizontal-separator></app-horizontal-separator>
    <span>{{pointsAddedThisMonth | number}}<mat-icon>stars</mat-icon></span>
    <span>{{t('points-added-this-month')}}</span>
    <app-horizontal-separator></app-horizontal-separator>
    <span>{{pointsRedeemedThisMonth | number}}<mat-icon>stars</mat-icon></span>
    <span>{{t('points-redeemed-month')}}</span>
    <app-horizontal-separator></app-horizontal-separator>
    <span>{{pointsExpiredLastYear | number}}<mat-icon>stars</mat-icon></span>
    <span>{{t('points-expired-december')}}{{getThisYear()-1}}</span>
    <app-horizontal-separator></app-horizontal-separator>
    <span>{{pointsExpiringThisMonth | number}}<mat-icon>stars</mat-icon></span>
    <span>{{t('points-expiring-month')}}</span>
    <app-horizontal-separator></app-horizontal-separator>
    <span>{{nextPointsExpiring | number}}<mat-icon>stars</mat-icon> - {{ nextPointsExpiringDate | date : 'MMM-dd-yyyy' : 'UTC' : language }}</span>
    <span>{{t('next-points-expiring')}}</span>
    <app-horizontal-separator></app-horizontal-separator>
    <span>{{pointsExpiringThisYear | number}}<mat-icon>stars</mat-icon></span>
    <span>{{t('points-expiring-december')}}{{getThisYear()}}</span>
    <app-horizontal-separator></app-horizontal-separator>
    <span>{{pointsExpiringNextYear | number}}<mat-icon>stars</mat-icon></span>
    <span>{{t('points-expiring-december')}}{{getThisYear()+1}}</span>
    <app-horizontal-separator *ngIf="registersOnVIPWindow"></app-horizontal-separator>
    <span *ngIf="registersOnVIPWindow">{{registersOnVIPWindow | number}}</span>
    <span *ngIf="registersOnVIPWindow">{{t('registers-on-this-vip-window')}}</span>
  </div>
</div>
